(function () {
  var MIN_SHRINK_RATIO = 0.72;

  function computeWorstRatio(elements) {
    var worst = 1;
    elements.forEach(function (el) {
      if (el.clientWidth > 0 && el.scrollWidth > el.clientWidth + 1) {
        var ratio = el.clientWidth / el.scrollWidth;
        if (ratio < worst) worst = ratio;
      }
    });
    return worst;
  }

  function fitGroup(elements) {
    if (!elements.length) return;

    // Reset to the CSS-computed (responsive) size before measuring.
    elements.forEach(function (el) {
      el.style.fontSize = '';
      el.classList.remove('product-highlights__wrap');
    });

    var ratio = computeWorstRatio(elements);
    if (ratio >= 1) return;

    if (ratio < MIN_SHRINK_RATIO) {
      // Shrinking enough to fit the longest item on one line would make
      // every item uncomfortably small. Wrap to two lines instead, applied
      // uniformly so every feature still matches.
      elements.forEach(function (el) {
        el.classList.add('product-highlights__wrap');
      });
      return;
    }

    var safeRatio = ratio * 0.98;
    elements.forEach(function (el) {
      var baseSize = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = baseSize * safeRatio + 'px';
    });
  }

  function fitAll() {
    document.querySelectorAll('.product-highlights').forEach(function (container) {
      var titles = Array.prototype.slice.call(
        container.querySelectorAll('.product-highlights__text strong')
      );
      var labels = Array.prototype.slice.call(
        container.querySelectorAll('.product-highlights__text span')
      );
      fitGroup(titles);
      fitGroup(labels);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }

  document.addEventListener('shopify:section:load', fitAll);

  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(fitAll, 150);
  });
})();
